module.exports = __webpack_public_path__ + "static/media/we-fight-togother.58bda401.jpg";